jQuery(document).ready(function($) {
  let selectedProducts = {};

  // Variant change → update image + button state
  $('.variant-selector').on('change', function() {
    let $select = $(this);
    let variantId = $select.val();
    let imgUrl = $select.find(':selected').data('img') || $select.data('img');
    let available = $select.find(':selected').data('available') || $select.data('available');
    let $card = $select.closest('.selected-product-card');
    let $btn = $card.find('.add-to-box-btn');

    // Set variant on button
    $btn.attr('data-variant', variantId);

    // Change image safely
    if (imgUrl) {
      $card.find('.product-main-img').attr('src', imgUrl);
    }

    // Update button state based on availability
    if (available) {
      if (!$btn.hasClass('added')) {
        $btn.prop('disabled', false).text('Add to Box');
      }
    } else {
      $btn.prop('disabled', true).removeClass('added').text('Out of Stock');
      $card.removeClass('added');
      delete selectedProducts[variantId];
      toggleMainATC();
    }
  }).trigger('change');

  // Add to Box button
  $('.add-to-box-btn').on('click', function() {
    let $btn = $(this);
    let $card = $btn.closest('.selected-product-card');
    let variantId = $btn.attr('data-variant');
    let available = $card.find('.variant-selector option:selected').data('available') || $card.find('.variant-selector').data('available');

    if (!available) return; // stop if OOS

    if ($btn.hasClass('added')) {
      delete selectedProducts[variantId];
      $btn.removeClass('added').text('Add to Box');
      $card.removeClass('added');
      $card.find('.remove-from-box').hide();
    } else {
      selectedProducts[variantId] = 1;
      $btn.addClass('added').text('Added');
      $card.addClass('added');
      $card.find('.remove-from-box').show();
    }

    toggleMainATC();
  });

      // Remove with X button
      $('.remove-from-box').on('click', function() {
        let $card = $(this).closest('.selected-product-card');
        let variantId = $card.find('.add-to-box-btn').attr('data-variant');

        // Remove from selected list immediately
        delete selectedProducts[variantId];

        // Optimistic UI update
        $card.find('.add-to-box-btn')
          .removeClass('added')
          .text('Add to Box')
          .prop('disabled', false);
        $card.removeClass('added');
        $card.find('.remove-from-box').hide();
        toggleMainATC();

        // Call Shopify in background
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: variantId, quantity: 0 },
          dataType: 'json',
          error: function(err) {
            // Rollback if API fails
            selectedProducts[variantId] = 1;
            $card.find('.add-to-box-btn')
              .addClass('added')
              .text('Added')
              .prop('disabled', false);
            $card.find('.remove-from-box').show();
            $card.addClass('added');
            toggleMainATC();
            alert('Item already removed from cart. Refresh to update.');
            console.error(err);
          }
        });
      });


    // Main ATC button
    $('#add-all-to-cart').on('click', function() {
    if (Object.keys(selectedProducts).length === 0) return;

    let items = [];
    $.each(selectedProducts, function(variantId, qty) {
        items.push({ id: variantId, quantity: qty });
    });

    let $btn = $(this);
    $btn.prop('disabled', true).addClass('loading').html('<span class="spinner"></span> Adding...');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items },
        dataType: 'json',
        success: function() {
        $btn.removeClass('loading').text('Added to Cart').prop('disabled', true);
        },
        error: function(err) {
        $btn.removeClass('loading').text('Add To Cart').prop('disabled', false);
        alert('Error. Try again.');
        console.error(err);
        }
    });
    });


  // Enable/disable main ATC
  function toggleMainATC() {
    if (Object.keys(selectedProducts).length > 0) {
      $('#add-all-to-cart').prop('disabled', false).text('Add To Cart');
    } else {
      $('#add-all-to-cart').prop('disabled', true).text('Add To Cart');
    }
  }

  // Auto-mark from cart
  function markAddedFromCart() {
    $.getJSON('/cart.js', function(cart) {
      cart.items.forEach(function(item) {
        let variantId = item.id.toString();
        selectedProducts[variantId] = item.quantity;

        $('.selected-product-card').each(function() {
          let $card = $(this);
          let vid = $card.find('.add-to-box-btn').attr('data-variant');
          if (vid == variantId) {
            $card.find('.add-to-box-btn').addClass('added').text('Added').prop('disabled', false);
            $card.find('.remove-from-box').show();
            $card.addClass('added');
          }
        });
      });

      toggleMainATC();
    });
  }

  markAddedFromCart();
});